import React, { forwardRef } from 'react'
import './EMDRBall.css'

const EMDRBall = forwardRef(({ ballColor = '#0066ff', shape = 'circle', size = 1 }, ref) => {
  // Si c'est un emoji, on l'affiche directement
  const isEmoji = shape && shape.length <= 4 && shape !== 'circle'
  
  return (
    <div 
      ref={ref}
      className={`emdr-ball ${isEmoji ? 'emoji-shape' : 'circle-shape'}`}
      style={{ 
        backgroundColor: isEmoji ? 'transparent' : ballColor, 
        color: ballColor,
        borderColor: isEmoji ? 'transparent' : 'rgba(255, 255, 255, 0.8)'
      }}
      aria-hidden="true"
    >
      {isEmoji && <span className="emoji-content">{shape}</span>}
    </div>
  )
})

EMDRBall.displayName = 'EMDRBall'

export default EMDRBall 